import React from "react";
import { Plan } from "../../types/plans/plan";
import { CardHeading } from "./CardHeading";
import { PlanAccount } from "./PlanAccount";
import { StdPlanText } from "./StdPlanText";
import { UnlockPlanOrAlternative } from "./UnlockPlanOrAlternative";
import { UpsellCardBase } from "./UpsellCardBase";
import { useUpsellAnalytics } from "./useUpsellAnalytics";

export const AssuranceFeaturesCard = ({
  recommendedPlan,
  cheaperPlan,
  currentPlan,
  account,
}: {
  recommendedPlan: Plan;
  cheaperPlan: Plan;
  currentPlan: Plan | undefined;
  account: PlanAccount;
}) => {
  useUpsellAnalytics("default", recommendedPlan.name);

  return (
    <UpsellCardBase
      heading={
        <CardHeading>
          {currentPlan ? `Get supporting documents` : "Get your tax report"}
        </CardHeading>
      }
      content={
        <StdPlanText
          recommendedPlan={recommendedPlan}
          currentPlan={currentPlan}
          account={account}
          subtext={`Download supporting documents to keep you safe in an ATO audit or review.`}
        />
      }
      actions={
        <UnlockPlanOrAlternative
          account={account}
          currentPlan={currentPlan}
          recommendedPlan={recommendedPlan}
          cheaperPlan={cheaperPlan}
        />
      }
    />
  );
};
